module.exports = __webpack_public_path__ + "img/icon-lectura-de-correo.15922829.svg";